import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "impx-room-item medium uk-box-shadow-large" }
const _hoisted_2 = {
  class: "uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-grid",
  "data-uk-grid": ""
}
const _hoisted_3 = { class: "uk-card-media-left uk-cover-container uk-position-relative uk-first-column" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "uk-card-body uk-position-relative impx-padding-medium" }
const _hoisted_6 = { class: "uk-card-header uk-padding-remove-horizontal" }
const _hoisted_7 = { class: "uk-card-title uk-margin-remove-bottom" }
const _hoisted_8 = { class: "uk-text-meta uk-margin-remove-top" }
const _hoisted_9 = { class: "uk-card-badge uk-label bg-color-csa uk-text-bold" }
const _hoisted_10 = { class: "uk-list room-fac" }
const _hoisted_11 = { class: "uk-card-footer uk-padding-remove-horizontal uk-padding-remove-bottom" }

import {getCurrentInstance} from 'vue';
import Room from "@/models/Room";
import {useStore} from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'ApartmentItem',
  props: {
    roomItem: {}
  },
  setup(__props: any) {

const props = __props
const baseUri = process.env.VUE_APP_API_ASSET_URL;
const commodities = props.roomItem?.room_spec
    ? props.roomItem?.room_spec?.split(',') : [];
const {$router} = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
console.log("-*************test room properties**************");
console.log(props.roomItem.room_name)
const getRoomDetails = () => {
  store.dispatch('room/saveRoomChoose', props.roomItem)
  $router.push(`/apartment/${props.roomItem.id}/details`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("canvas", {
            width: "290",
            height: "180"
          }, null, -1)),
          _createElementVNode("img", {
            src: _ctx.roomItem?.room_photos?.[0] ? _unref(baseUri) + _ctx.roomItem.room_photos[0] : '',
            alt: "",
            "data-uk-cover": "",
            class: "uk-cover",
            style: {"width":"340px","height":"340px"}
          }, null, 8, _hoisted_4),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "impx-overlay light overlay-squared padding-xwide" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.roomItem.room_name), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.roomItem?.room_type?.room_type_name ?? ''), 1)
          ]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.roomItem.room_total_price) + " /nuitée", 1),
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commodities).slice(0, 3), (commod, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _cache[3] || (_cache[3] = _createElementVNode("span", {
                  class: "impx-text-aqua uk-icon",
                  "data-uk-icon": "icon: check; ratio: 1;"
                }, [
                  _createElementVNode("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20"
                  }, [
                    _createElementVNode("polyline", {
                      fill: "none",
                      stroke: "#000",
                      "stroke-width": "1.1",
                      points: "4,10 8,15 17,4"
                    })
                  ])
                ], -1)),
                _createTextVNode(" " + _toDisplayString(commod), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "uk-button uk-button-text impx-text-csa btn-outline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (getRoomDetails()))
            }, "Détails ")
          ])
        ])
      ])
    ])
  ]))
}
}

})